/**
 * 集采列表页筛选条件 sessionStorage 缓存（切换菜单后返回仍保留）。
 * 缓存键：BMS_CP_LIST_FILTER_ + 路由 path（不含前导 /），如 cpSettlementSalePurchaseOrder。
 */

const PREFIX = 'BMS_CP_LIST_FILTER_';

/** 生成缓存键 */
export function cpFilterCacheKey(routePath) {
  const p = (routePath || '').replace(/^\//, '');
  return PREFIX + p;
}

/** 保存筛选快照 */
export function saveCpFilterCache(routePath, data) {
  if (!routePath || !data) return;
  try {
    sessionStorage.setItem(cpFilterCacheKey(routePath), JSON.stringify(data));
  } catch (e) {
    /* 存储满等情况忽略 */
  }
}

/** 读取筛选快照，无缓存返回 null */
export function loadCpFilterCache(routePath) {
  if (!routePath) return null;
  try {
    const raw = sessionStorage.getItem(cpFilterCacheKey(routePath));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

/** 清除当前路由筛选缓存（重置时调用） */
export function clearCpFilterCache(routePath) {
  if (!routePath) return;
  sessionStorage.removeItem(cpFilterCacheKey(routePath));
}

/**
 * 将路由 path 设为组件 name，供 Home keep-alive :include 按页签路由缓存实例。
 * 调用处：created / beforeRouteUpdate。
 */
export function applyCpKeepAliveRouteName(vm, routePath) {
  const routeKey = (routePath || '').replace(/^\//, '');
  if (routeKey && vm && vm.$options) {
    vm.$options.name = routeKey;
  }
}
